/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import { BaseQueryFn } from '@reduxjs/toolkit/query';
import { AxiosRequestConfig } from 'axios';
import { getHttpClient } from './HttpClient';

const httpClient = getHttpClient();
export interface AxiosQueryMeta {
  headers?: Record<string, string>;
}

export const axiosBaseQuery =
  (): BaseQueryFn<
    {
      url: string;
      method: AxiosRequestConfig['method'];
      data?: AxiosRequestConfig['data'];
      params?: AxiosRequestConfig['params'];
      headers?: AxiosRequestConfig['headers'];
      withCredentials?: AxiosRequestConfig['withCredentials'];
      responseType?: AxiosRequestConfig['responseType'];
    },
    unknown,
    { message: string; name: string },
    unknown,
    AxiosQueryMeta
  > =>
  async ({ url, method, data, params, headers, withCredentials, responseType }) => {
    const result = await httpClient.request({ url, method, data, params, headers, withCredentials, responseType });

    // Include headers in meta for blob responses (needed for Content-Disposition)
    if (responseType === 'blob') {
      return {
        data: result.data,
        meta: { headers: Object.fromEntries(
          Object.entries(result.headers).filter((entry): entry is [string, string] => typeof entry[1] === 'string'),
        ) },
      };
    }

    return { data: result.data };
  };
